import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import "./PendingApproval.css";

const PendingApproval = () => {
    const { t } = useTranslation();
    const { user, logout } = useAuth();

    return (
        <div className="pending-page">
            <div className="pending-page__card">
                <div className="pending-page__icon">⏳</div>
                <h1 className="pending-page__title">
                    Application Under Review
                </h1>
                <p className="pending-page__message">
                    {t("dashboard.pendingMessage")}
                </p>
                {user && (
                    <p className="pending-page__email">
                        We'll reach out to <strong>{user.email}</strong>
                    </p>
                )}
                <button className="btn btn--ghost" onClick={logout}>
                    {t("nav.logout")}
                </button>
            </div>
        </div>
    );
};

export default PendingApproval;
